import React, { useState, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SecretMessage from "../pages/SecretMessage";
import LinkDisplay from "../components/secretmessage/LinkDisplay";
import SecretById from "../pages/SecretById";
import SecretMessageBlog from "../pages/SecretMessageBlog";
import LanguageRoute from "../components/common/LanguageRoute";

const Router = () => {
  const storedLink = localStorage.getItem("link");
  const [link, setLink] = useState(storedLink);
  const [userId, setUserId] = useState(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(storedUserId);
    }
  }, []);

  const handleLinkGenerated = (generatedLink) => {
    setLink(generatedLink);
    localStorage.setItem("link", generatedLink);
  };

  useEffect(() => {
    if (link) {
      const parts = link.split('/');
      if (parts.length > 2) {
        parts[3] = i18n.language; 
        const newLink = parts.join('/');        
        setLink(newLink);
        localStorage.setItem("link", newLink);
      }
    }
  }, [i18n.language]);

  return (
    <>
      <Routes>
        {/* Redirect root to current language */}
        <Route path="/" element={<Navigate to={`/${i18n.language || 'en'}`} replace />} />

        {/* Routes with language prefix */}
        <Route path="/:lang" element={
          <LanguageRoute>
            {userId || link ? (
              <LinkDisplay link={link || storedLink} />
            ) : (
              <SecretMessage onLinkGenerated={handleLinkGenerated} />
            )}
          </LanguageRoute>
        } />

        <Route path="/:lang/secret/:id" element={
          <LanguageRoute>
            <SecretById />
          </LanguageRoute>
        } />

        <Route path="/:lang/blogs" element={
          <LanguageRoute>
            <SecretMessageBlog />
          </LanguageRoute>
        } />

        {/* Legacy routes without language prefix (for backward compatibility) */}
        <Route path="/secret/:id" element={<SecretById />} />
        <Route path="/blogs" element={<SecretMessageBlog />} />
      </Routes>
    </>
  );
};

export default Router;
